module.exports = __webpack_public_path__ + "static/media/Column-Views.31a1b132.svg";